const getActiveProfileFromParams = props =>
  props.stores.profilesStore.profiles.find(p => p.id === props.match.params.profileId) || props.stores.profilesStore.profiles[0];

export {getActiveProfileFromParams};
export default getActiveProfileFromParams;
